import types from './mutations-types';

const mutations = {
  [types.SET_CLIENTS](state, payload) {
    state.myClients = payload;
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/modules/clients/mutations.js